export const POST_POSTDETAILS = 'POST_POSTDETAILS';
export const LIST_POSTDETAILS = 'LIST_POSTDETAILS';
export const GET_POSTDETAILS = 'GET_POSTDETAILS';
